import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import CircleIcon from '@mui/icons-material/Circle';

export const DotsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const loadingAnimation = keyframes`
  0%, 20% {
    opacity: 0;
    transform: scale(0.6);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
  80%, 100% {
    opacity: 0;
    transform: scale(0.6);
  }
`;

export const Dot = styled.span`
  opacity: 0;
  margin: 0;
  animation: ${loadingAnimation} 1s infinite;

  &:nth-of-type(1) {
    animation-delay: 0s;
  }
  &:nth-of-type(2) {
    animation-delay: 0.3333s;
  }
  &:nth-of-type(3) {
    animation-delay: 0.6666s;
  }
`;

export const StyledDotIcon = styled(CircleIcon, {
  shouldForwardProp: (prop) => !['height'].includes(prop),
})<{ height?: string }>`
  display: flex;
  height: ${({ height }) => (height ? `${height}px` : 'var(--spacing-12)')};
  width: ${({ height }) => (height ? `${height}px` : 'var(--spacing-12)')};
  color: var(--color-black);
  transition:
    height 0.3s ease,
    width 0.3s ease;
`;
